"use client";

import Image from "next/image";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

export default function UserEmpowerment() {
    return (
        <div className="/*bg-bluebirdlightblue*/">
            <h1 className="text-4xl p-4 pl-12">User Empowerment</h1>
            <p className="pl-12 pr-12 pb-4">
                For user empowerment, we use insights from social and behavioural science to help people <strong>actively engage in energy flexibility 
                and demand-response</strong>. By combining psychological research and behaviour change models with intuitive tools and explainable AI, 
                we support users in <strong>understanding their options</strong>, making <strong>informed decisions</strong>, and <strong>adopting sustainable practices over the long term</strong>. 
                We directly work with people in our Pilots to empower them within the project and beyond. 
            </p>
            <div className="relative w-full max-w-4xl mx-auto">
                {/* Wrapper for Image and Hotspots */}
                <div className="relative w-full">
                    {/* Main figure */}
                    <Image
                        src="/projectoverview/userresearch.png"
                        alt="Project Concept"
                        width={900}
                        height={200}
                        className="object-cover"
                    />

                    {/* --- Hotspot 1: Research --- */}
                    <div
                        data-tooltip-id="research-tooltip"
                        data-tooltip-html="We explore what enables or limits people’s ability to participate in<br />
                                           flexibility actions (= Empowerment). Using the COM-B model (capability,<br />
                                           opportunity, motivation), we analyse user needs through literature<br />
                                           reviews, large-scale surveys, and interviews/focus groups. This<br /> 
                                           combination of qualitative and quantitative research helps us understand<br />
                                           everyday barriers and identify what truly empowers building users."
                        className="absolute top-[23%] left-[9%] w-[21%] h-[15%] /*bg-red-500/40 hover:bg-blue-500/40*/ cursor-pointer z-10"
                    />

                    {/* --- Hotspot 2: Empowerment Tools --- */}
                    <div
                        data-tooltip-id="empowerment-tooltip"
                        data-tooltip-html="We develop interactive tools that help people understand and<br /> 
                                           practice flexibility behaviors. Examples are the 'Demand Response <br />
                                           Simulation Game' - a guided virtual environment where users test<br /> 
                                           decisions during demand-response events; or the 'Flexibility Quiz'<br />
                                           -  a playful way to learn key concepts and reveal knowledge gaps across<br />
                                           different user groups. Together with user-friendly interface designs,<br />
                                           these tools build confidence and literacy around flexibility options."
                        className="absolute top-[9%] left-[53%] w-[23%] h-[16%] /*bg-red-500/40 hover:bg-blue-500/40*/ cursor-pointer z-10"
                    />

                    {/* --- Hotspot 3: Demo Support --- */}
                    <div
                        data-tooltip-id="demo-support-tooltip"
                        data-tooltip-html="We translate insights into practical support for real-world pilot sites.<br /> 
                                           This includes creating user personas, designing use cases and experimental<br />
                                           field trials; and offering clear guidelines and recommendations. The goal is to<br /> 
                                           help demos design solutions that fit users’ needs, encourage participation, and<br />
                                           ensure that flexibility systems work for diverse households and communities."
                        className="absolute top-[49%] left-[53%] w-[22%] h-[15%] /*bg-red-500/40 hover:bg-blue-500/40*/ cursor-pointer z-10"
                    />

                </div>

                {/* Tooltips */}
                <ReactTooltip id="research-tooltip" place="top" className="!bg-bluebirdyellow !text-black !rounded-md !opacity-100" />
                <ReactTooltip id="empowerment-tooltip" place="top" className="!bg-bluebirdyellow !text-black !rounded-md !opacity-100" />
                <ReactTooltip id="demo-support-tooltip" place="top" className="!bg-bluebirdyellow !text-black !rounded-md !opacity-100" />

                <p className="text-right text-sm mb-4 mt-8 italic">
                    💡 Hover over the different components for more information
                </p>
            </div>
        </div>
    )
}